import { envConfig } from "@env/env-config"

export class PaypalHelper {

    public static loadPaypalScriptLabel() {
        const client_id = envConfig.getPaypalClientId();

        const url = 'https://www.paypal.com/sdk/js';
        const queryString = `?client-id=${client_id}&components=buttons`;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url + queryString;
        script.async = true;
        script.defer = true;
        script.id = "paypal-sdk";
        
        document.body.appendChild(script);
    }
}